import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute3 = ({
  width = 288,
  height = 333,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 382,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 288 333"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M20.0007,62.9999C43.3174,96.2085 63.5403,133.492 68.7098,158.607C78.824,207.746 130.266,258.836 174.028,233.574C205.597,215.35 258.001,223 287.501,256.5"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M20.0007,62.9999C43.3174,96.2085 63.5403,133.492 68.7098,158.607C78.824,207.746 130.266,258.836 174.028,233.574C205.597,215.35 258.001,223 287.501,256.5"
      />
      <path
        opacity={0}
        ref={forwardRef.arrow}
        d="M17.6472 59.7584C17.6405 59.5275 17.8863 59.376 18.0895 59.4857L23.6785 62.5019C23.8817 62.6115 23.89 62.9001 23.6934 63.0213L18.2869 66.3534C18.0903 66.4745 17.8362 66.3374 17.8296 66.1066L17.6472 59.7584Z"
        fill={stroke}
      />
    </svg>
  )
}

export default ExpeditionRoute3
